var _excluded = ["className", "localeFormatting", "onNext", "onPageChange", "onPrevious", "onResultsPerPageChange", "page", "resultsPerPage", "showText", "showFirstLastButtons", "showSetPageInput", "total"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useEffect, useState } from "react";
import { keyCodes } from "../../utils/helpers";
import AButton from "../AButton";
import AButtonGroup from "../AButtonGroup";
import ATextInput from "../ATextInput";
import AIcon from "../AIcon";
import "./APagination.scss";
var ICON_SIZE = 10;
var APagination = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var propsClassName = _ref.className,
    localeFormatting = _ref.localeFormatting,
    onNext = _ref.onNext,
    onPageChange = _ref.onPageChange,
    onPrevious = _ref.onPrevious,
    onResultsPerPageChange = _ref.onResultsPerPageChange,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? 1 : _ref$page,
    resultsPerPage = _ref.resultsPerPage,
    showText = _ref.showText,
    _ref$showFirstLastBut = _ref.showFirstLastButtons,
    showFirstLastButtons = _ref$showFirstLastBut === void 0 ? true : _ref$showFirstLastBut,
    _ref$showSetPageInput = _ref.showSetPageInput,
    showSetPageInput = _ref$showSetPageInput === void 0 ? true : _ref$showSetPageInput,
    total = _ref.total,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(resultsPerPage),
    _useState2 = _slicedToArray(_useState, 2),
    workingResultsPerPage = _useState2[0],
    setWorkingResultsPerPage = _useState2[1];
  var _useState3 = useState(page),
    _useState4 = _slicedToArray(_useState3, 2),
    workingPage = _useState4[0],
    setWorkingPage = _useState4[1];
  useEffect(function () {
    setWorkingResultsPerPage(resultsPerPage);
  }, [resultsPerPage]);
  useEffect(function () {
    setWorkingPage(page);
  }, [page]);
  var getNewPage = function getNewPage(newResultsPerPage) {
    var currentResult = (page - 1) * resultsPerPage + 1;
    var newPage = (currentResult - 1) / newResultsPerPage + 1;
    return Math.floor(newPage);
  };
  var className = "a-pagination";
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var content = function content() {
    if (total && resultsPerPage) {
      var pages = Math.ceil(total / resultsPerPage);
      var firstResultIndex = (page - 1) * resultsPerPage + 1;
      var lastResultIndex = Math.min(total, (page - 1) * resultsPerPage + resultsPerPage);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "a-pagination__results-per-page"
      }, /*#__PURE__*/React.createElement(ATextInput, {
        spinner: false,
        onBlur: function onBlur() {
          if (!workingResultsPerPage) {
            setWorkingResultsPerPage(1);
            onResultsPerPageChange && onResultsPerPageChange(1);
            onPageChange && onPageChange(getNewPage(1));
            return;
          }
          onResultsPerPageChange && onResultsPerPageChange(workingResultsPerPage);
          onPageChange && onPageChange(getNewPage(workingResultsPerPage));
        },
        onChange: function onChange(e) {
          return setWorkingResultsPerPage(Math.min(Math.max(parseInt(e.target.value), 1), total));
        },
        onKeyDown: function onKeyDown(e) {
          if (onResultsPerPageChange && e.keyCode === keyCodes.enter) {
            e.preventDefault();
            if (!workingResultsPerPage) {
              setWorkingResultsPerPage(1);
              onResultsPerPageChange && onResultsPerPageChange(1);
              onPageChange && onPageChange(getNewPage(1));
              return;
            }
            onResultsPerPageChange(workingResultsPerPage);
            onPageChange && onPageChange(getNewPage(workingResultsPerPage));
          }
        },
        value: workingResultsPerPage || "",
        type: "number"
      }), "per page"), /*#__PURE__*/React.createElement("div", {
        className: "a-pagination__results"
      }, localeFormatting ? firstResultIndex.toLocaleString() : firstResultIndex, "-", localeFormatting ? lastResultIndex.toLocaleString() : lastResultIndex, " ", "of ", localeFormatting ? total.toLocaleString() : total), showFirstLastButtons && /*#__PURE__*/React.createElement(AButton, {
        className: "a-pagination__first",
        disabled: page === 1,
        tertiaryAlt: true,
        icon: true,
        onClick: function onClick() {
          return onPageChange(1);
        },
        "aria-label": "First"
      }, /*#__PURE__*/React.createElement(AIcon, {
        size: ICON_SIZE
      }, "caret-double-left")), /*#__PURE__*/React.createElement(AButton, {
        className: "a-pagination__previous",
        disabled: page === 1,
        tertiaryAlt: true,
        icon: true,
        onClick: function onClick() {
          return onPageChange(page - 1);
        },
        "aria-label": "Previous"
      }, /*#__PURE__*/React.createElement(AIcon, {
        left: showText,
        size: ICON_SIZE
      }, "caret-left")), /*#__PURE__*/React.createElement("div", {
        className: "a-pagination__page-selection"
      }, showSetPageInput ? /*#__PURE__*/React.createElement(ATextInput, {
        spinner: false,
        onBlur: function onBlur() {
          if (!workingPage) {
            setWorkingPage(1);
            onPageChange && onPageChange(1);
            return;
          }
          onPageChange && onPageChange(workingPage);
        },
        onChange: function onChange(e) {
          return setWorkingPage(Math.min(Math.max(parseInt(e.target.value), 1), pages));
        },
        onKeyDown: function onKeyDown(e) {
          if (onPageChange && e.keyCode === keyCodes.enter) {
            e.preventDefault();
            if (!workingPage) {
              setWorkingPage(1);
              onPageChange && onPageChange(1);
              return;
            }
            onPageChange && onPageChange(workingPage);
          }
        },
        value: workingPage || "",
        type: "number"
      }) : workingPage, " / ", localeFormatting ? pages.toLocaleString() : pages), /*#__PURE__*/React.createElement(AButton, {
        className: "a-pagination__next",
        disabled: page === pages,
        tertiaryAlt: true,
        icon: true,
        onClick: function onClick() {
          return onPageChange(page + 1);
        },
        "aria-label": "Next"
      }, /*#__PURE__*/React.createElement(AIcon, {
        right: showText,
        size: ICON_SIZE
      }, "caret-right")), showFirstLastButtons && /*#__PURE__*/React.createElement(AButton, {
        className: "a-pagination__last",
        disabled: page === pages,
        tertiaryAlt: true,
        icon: true,
        onClick: function onClick() {
          return onPageChange(pages);
        },
        "aria-label": "Last"
      }, /*#__PURE__*/React.createElement(AIcon, {
        right: showText,
        size: ICON_SIZE
      }, "caret-double-right")));
    }
    if (total) {
      // PADDING is what to show around the current page.
      // If on page 50 of 100 pages, show 48, 49, 50, 51, 52
      var PADDING = 2;

      // START_END_LENGTH is how much of the beginning to show
      // If you're on page 50 of 100, show 1, 2, 3 in the start section
      // and 98, 99, 100 in the end section.
      var START_END_LENGTH = 1 + PADDING;
      var start = page - PADDING;
      var end = page + PADDING;
      var startPages = [];
      var endPages = [];
      if (page <= 1 + PADDING + START_END_LENGTH) {
        start = 1;
      } else {
        startPages = Array.from(Array(START_END_LENGTH), function (_, x) {
          return x + 1;
        });
      }
      if (total - PADDING - START_END_LENGTH <= page) {
        end = total;
      } else {
        endPages = Array.from(Array(START_END_LENGTH), function (_, x) {
          return total - x;
        }).reverse();
      }
      var midPages = Array.from(Array(end - start + 1), function (_, x) {
        return x + start;
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AButton, {
        className: "a-pagination__previous",
        disabled: page === 1,
        tertiaryAlt: true,
        icon: !showText,
        onClick: function onClick() {
          return onPageChange(page - 1);
        },
        "aria-label": "Previous"
      }, /*#__PURE__*/React.createElement(AIcon, {
        left: showText,
        size: ICON_SIZE
      }, "caret-left"), showText && "Previous"), !!startPages.length && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AButtonGroup, {
        selectedValues: [page],
        onChange: function onChange(selectedValue) {
          return onPageChange(selectedValue);
        }
      }, startPages.map(function (x) {
        return /*#__PURE__*/React.createElement(AButton, {
          value: x,
          key: x
        }, localeFormatting ? x.toLocaleString() : x);
      })), "\u2026"), midPages.length && /*#__PURE__*/React.createElement(AButtonGroup, {
        selectedValues: [page],
        onChange: function onChange(selectedValue) {
          return onPageChange(selectedValue);
        }
      }, midPages.map(function (x) {
        return /*#__PURE__*/React.createElement(AButton, {
          value: x,
          key: x
        }, localeFormatting ? x.toLocaleString() : x);
      })), !!endPages.length && /*#__PURE__*/React.createElement(React.Fragment, null, "\u2026", /*#__PURE__*/React.createElement(AButtonGroup, {
        selectedValues: [page],
        onChange: function onChange(selectedValue) {
          return onPageChange(selectedValue);
        }
      }, endPages.map(function (x) {
        return /*#__PURE__*/React.createElement(AButton, {
          value: x,
          key: x
        }, localeFormatting ? x.toLocaleString() : x);
      }))), /*#__PURE__*/React.createElement(AButton, {
        className: "a-pagination__next",
        disabled: page === total,
        tertiaryAlt: true,
        icon: !showText,
        onClick: function onClick() {
          return onPageChange(page + 1);
        },
        "aria-label": "Next"
      }, showText && "Next", /*#__PURE__*/React.createElement(AIcon, {
        right: showText,
        size: ICON_SIZE
      }, "caret-right")));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AButton, {
      className: "a-pagination__previous",
      disabled: !onPrevious,
      onClick: function onClick(e) {
        return onPrevious(e);
      },
      "aria-label": "Previous"
    }, /*#__PURE__*/React.createElement(AIcon, {
      left: true,
      size: ICON_SIZE
    }, "caret-left"), "Previous"), /*#__PURE__*/React.createElement(AButton, {
      className: "a-pagination__next",
      disabled: !onNext,
      onClick: function onClick(e) {
        return onNext(e);
      },
      "aria-label": "Next"
    }, "Next", /*#__PURE__*/React.createElement(AIcon, {
      right: true,
      size: ICON_SIZE
    }, "caret-right")));
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: ref,
    className: className
  }), content());
});
APagination.propTypes = {
  /**
   * Sets numeric displays to be locale formatted.
   */
  localeFormatting: PropTypes.bool,
  /**
   * Handles the activation of the `Next` button when the number of pages isn't determined.
   */
  onNext: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  /**
   * Handles updates to the current page.
   */
  onPageChange: PropTypes.func,
  /**
   * Handes the activation of the `Previous` button when the number of pages isn't determined.
   */
  onPrevious: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  /**
   * Handles the submission of results per page values.
   */
  onResultsPerPageChange: PropTypes.func,
  /**
   * Sets the current page.
   */
  page: PropTypes.number,
  /**
   * Sets the results per page.
   */
  resultsPerPage: PropTypes.number,
  /**
   * Toggles whether text is shown on the Previous/Next buttons in the button group view.
   */
  showText: PropTypes.bool,
  /**
   * Sets the total number or results if `resultsPerPage` is defined, otherwise sets the total number of pages.
   */
  total: PropTypes.number,
  /**
   * Show the jump to first and jump to last buttons.
   */
  showFirstLastButtons: PropTypes.bool,
  /**
   * Show the set page text input. If false, shows the current page number as text.
   */
  showSetPageInput: PropTypes.bool
};
APagination.displayName = "APagination";
export default APagination;